// extracted by mini-css-extract-plugin
export default {"wrapper":"PreviewCourse_wrapper__Hj0SU","body":"PreviewCourse_body__IUQfl"};